import { render } from "./DropdownGroupCustom.vue?vue&type=template&id=7af34257"
import script from "./DropdownGroupCustom.vue?vue&type=script&lang=js"
export * from "./DropdownGroupCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__